/*
|
|               User
_______________________________________________
|
|    This class keep all fields for 
|    new user.
|
*/

export class User {
    
    city                 :string  = '';
    comission_percent   ?:number  = 0;
    referrer_comission  ?:number  = 0;
    referrer_comission_dollar ?:number = 0;
    referrer_comission_type ?:string  = 'gross'
    comission_dollar    ?:number = 0;
    comission_type      ?:string  = 'gross';
    country              :string  = '';
    email                :string  = '';
    firstName            :string  = '';
    fresh_login          :boolean = true;
    id                   :any     = '';
    manager              :number;
    notes                :string  = '';
    password             :string  = '';
    phone                :string  = '';
    state                :string  = '';
    street               :string  = '';
    referredBy           :any     = '';
    role                 :string  = '';
    secondName           :string  = '';
    status               :string  = 'active';
    zipCode              :string  = '';

}


// WEBPACK FOOTER //
// /root/anvel/angular/classes/User.ts